export const ficheConstants = {
    FICHE_LOADING: 'FICHE_LOADING',
    GETFICHE_SUCCESS: 'GET_FICHE_SUCCESS',
    GETFICHE_FAILURE: 'GET_FICHE_FAILURE',
    PUTFICHE_SUCCESS: 'PUT_FICHE_SUCCESS',
    PUTFICHE_FAILURE: 'PUT_FICHE_FAILURE',
}
